import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { cn } from '@/lib/utils';

interface RichTextEditorProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}

export function RichTextEditor({ value, onChange, placeholder, className }: RichTextEditorProps) {
  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['link', 'clean'],
    ],
  };

  const formats = [
    'header',
    'bold', 'italic', 'underline', 'strike',
    'list', 'bullet',
    'link',
  ];

  return (
    <div className={cn("rich-text-editor-container", className)}>
      <style>{`
        .rich-text-editor-container .ql-toolbar {
          border-color: #292524 !important; /* stone-800 */
          background-color: #1c1917 !important; /* stone-900 */
          border-top-left-radius: 16px;
          border-top-right-radius: 16px;
          padding: 12px;
        }
        .rich-text-editor-container .ql-container {
          border-color: #292524 !important; /* stone-800 */
          background-color: rgba(28, 25, 23, 0.5) !important; /* stone-900/50 */
          border-bottom-left-radius: 16px;
          border-bottom-right-radius: 16px;
          min-height: 200px;
          font-family: inherit;
          font-size: 0.875rem;
        }
        .rich-text-editor-container .ql-editor {
          min-height: 200px;
          color: #f5f5f4; /* stone-100 */
        }
        .rich-text-editor-container .ql-editor.ql-blank::before {
          color: #78716c; /* stone-500 */
          font-style: normal;
        }
        .rich-text-editor-container .ql-snow.ql-toolbar button {
          color: #a8a29e; /* stone-400 */
        }
        .rich-text-editor-container .ql-snow.ql-toolbar button:hover,
        .rich-text-editor-container .ql-snow.ql-toolbar button.ql-active {
          color: #f97316; /* orange-500 */
        }
        .rich-text-editor-container .ql-snow.ql-toolbar button:hover .ql-stroke,
        .rich-text-editor-container .ql-snow.ql-toolbar button.ql-active .ql-stroke {
          stroke: #f97316 !important;
        }
        .rich-text-editor-container .ql-snow.ql-toolbar button .ql-stroke {
          stroke: #a8a29e !important;
        }
        .rich-text-editor-container .ql-snow.ql-toolbar button .ql-fill {
          fill: #a8a29e !important;
        }
        .rich-text-editor-container .ql-snow.ql-toolbar .ql-picker {
          color: #a8a29e !important;
        }
        .rich-text-editor-container .ql-snow.ql-toolbar .ql-picker-options {
          background-color: #1c1917 !important;
          border-color: #292524 !important;
        }
      `}</style>
      <ReactQuill
        theme="snow"
        value={value}
        onChange={onChange}
        modules={modules}
        formats={formats}
        placeholder={placeholder}
      />
    </div>
  );
}
